import ACCOUNT_ROUTES from '../../../constants/account-routes';
import { Link } from 'react-router-dom';
import { TrackedButton } from '@blueshift-ui/analytics';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

function BackToAccountButton({ children, ...buttonProps }: React.PropsWithChildren<object>) {
  const { translate } = useTranslation('membership');

  return (
    <TrackedButton
      component={Link}
      id="back_to_account_button"
      to={`/${ACCOUNT_ROUTES.membership}`}
    >
      {children || translate('back_to_account_cta', '')}
    </TrackedButton>
  );
}

export default BackToAccountButton;
